import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{
 *   $refs: {
 *     play: HTMLButtonElement;
 *     videoPlayer: HTMLVideoElement;
 *     videoCover: HTMLElement;
 *   }
 * }} VideoProps
 */

/**
 * Video component.
 * @augments {Base<VideoProps>}
 */
export default class Wishlist extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Wishlist',
    options: {
      postId: String,
    },
    refs: ['icon'],
    emits: ['event'],
  };

  /**
   *
   */
  onClick() {
    this.$refs.icon.classList.toggle('*:fill-current');

    fetch('/wp/wp-admin/admin-ajax.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `action=handle_wishlist&post_id=${this.$options.postId}&security=custom_nonce`,
    })
      .then((response) => response.json())
      .then((response) => {
        this.$emit('event', response.data);
      });
  }
}
